import { Post } from "./common";

export default class MailingListService {
  static create = async (data: any) =>
    await Post({ path: "mailing-lists", body: data });
}
